export default __webpack_public_path__ + "static/media/footer6.0cc01ad2.png";